import { jsx } from "react/jsx-runtime";
import { COMPONENT_MAP } from "./types.js";
import { ScaffoldingContainer } from "./styles.js";
const FlyoutComposer = ({
  entry,
  locale,
  width = "normal"
}) => {
  if (!entry) {
    return null;
  }
  const flyoutScaffolding = entry.map((entry2, index) => {
    const type = Object.keys(entry2)[0];
    const Component = COMPONENT_MAP[type];
    return /* @__PURE__ */ jsx(
      Component,
      {
        columnSx: { display: "flex", flexDirection: "column", gap: 2 },
        entry: entry2[type],
        locale
      },
      index
    );
  });
  return /* @__PURE__ */ jsx(ScaffoldingContainer, { maxWidth: width === "wide" ? "976px" : "600px", children: flyoutScaffolding });
};
export {
  FlyoutComposer
};
